import Layout from "../components/site/Layout";
import { PageHeader } from "../components/site/Primitives";
import GatedForm from "../components/site/GatedForm";
import { Link } from "react-router-dom";

const BULLETS = [
  "Conventional illiquid-asset approach vs. RTC's structure-driven approach across all key dimensions",
  "Illustrative discount ranges (25–35%+) and the factors that determine where a specific structure falls",
  "Client role as LLC manager vs. IRA role as minority member — explained for non-technical readers",
  "How operating agreement provisions drive the discount — without illiquid asset lock-ups",
  "Compliance documentation requirements and the independent appraisal process",
];

const ROLE_OPTIONS = [
  "Prospective Client",
  "CPA or Tax Professional",
  "CFP or Financial Advisor or RIA",
  "Estate Planning Attorney",
  "Other Financial Professional",
];

const DISCLAIMER =
  "This document is shared in confidence and is not intended for redistribution. By submitting, you acknowledge that the content is proprietary to Retirement Tax Consultants, LLC and is provided for informational purposes only. You may receive a brief follow-up from our team.";

const TEST_IDS = {
  form: "strategy-comparison-form",
  success: "strategy-success",
  prefix: "strategy",
};

export default function StrategyComparisonGatePage() {
  return (
    <Layout pageName="strategy-comparison-gate">
      <PageHeader
        eyebrow="Gated Resource · Strategy Comparison"
        title="IRA-LLC Roth Conversion"
        italicTail="Strategy Comparison"
        intro="A side-by-side comparison of the conventional illiquid-asset approach and RTC's structure-driven IRA-LLC methodology — including holding period, discount range, client control, and implementation requirements."
      />

      <section className="pb-24 lg:pb-32 bg-cream">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <div className="text-[10px] tracking-overline uppercase font-semibold text-accent-gold mb-6">
              What&rsquo;s Inside
            </div>
            <ul className="border-t border-sage-soft">
              {BULLETS.map((b, i) => (
                <li
                  key={b}
                  className="grid grid-cols-12 gap-4 py-5 border-b border-sage-soft items-start"
                >
                  <div className="col-span-1 text-[10px] tracking-overline font-semibold text-accent-gold pt-1">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="col-span-11 text-deep-teal text-base leading-relaxed">
                    {b}
                  </div>
                </li>
              ))}
            </ul>

            <div className="mt-10 bg-cream-alt p-7 lg:p-8">
              <p className="text-sm text-charcoal-teal leading-relaxed">
                Need more depth? The White Paper provides a full legal
                analysis, IRS guidance citations, and Tax Court case table —
                designed for financial professionals conducting due diligence.{" "}
                <Link
                  to="/white-paper-gate"
                  className="text-accent-gold editorial-link font-semibold"
                >
                  Access the White Paper →
                </Link>
              </p>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="bg-cream-alt p-8 lg:p-10 border border-sage/30">
              <GatedForm
                endpoint="/lead-magnet/strategy-comparison"
                trackingEvent="strategy_comparison_submit"
                eyebrow="Request Document"
                title="Send me the comparison."
                submitLabel="Send Me the Comparison Document"
                roles={ROLE_OPTIONS}
                disclaimer={DISCLAIMER}
                testIds={TEST_IDS}
              />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
